module.exports = __webpack_public_path__ + "static/img/more-exam.7c9c7161.png";